module.exports = "/_next/static/images/img__card-2-touch-8fe8f6b8e4b2cab034ce13339fa9cf46.png";